import { cn, useSidebar } from '@1trading/react';
import { Menu } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { getMobilePrimaryNavItems, isNavItemActive } from '@/layouts/nav';

const ITEM_CLASS =
  'relative flex flex-1 flex-col items-center justify-center gap-1 text-muted-foreground transition-colors before:absolute before:inset-x-5 before:top-0 before:h-0.5 before:scale-x-0 before:rounded-full before:bg-primary before:transition-transform before:duration-200 active:text-foreground';
const ITEM_ACTIVE_CLASS = 'text-primary before:scale-x-100';
const ITEM_LABEL_CLASS = 'line-clamp-1 px-1 text-[0.6875rem] leading-none';

// The sidebar is a Sheet on mobile with no trigger of its own, so this bar is the only
// way into navigation below `md`.
export const BottomNav = () => {
  const { pathname } = useLocation();
  const { openMobile, setOpenMobile } = useSidebar();
  const items = getMobilePrimaryNavItems();

  return (
    <nav aria-label="Primary" className="fixed inset-x-0 bottom-0 z-40 border-t bg-sidebar pb-[env(safe-area-inset-bottom)] md:hidden">
      <div className="flex h-(--bottom-nav-height) items-stretch">
        {items.map(({ icon: Icon, ...item }) => {
          const isActive = isNavItemActive(pathname, item.to);

          return (
            <Link
              aria-current={isActive ? 'page' : undefined}
              aria-label={item.title}
              className={cn(ITEM_CLASS, isActive && ITEM_ACTIVE_CLASS)}
              key={item.to}
              onClick={() => setOpenMobile(false)}
              to={item.to}
            >
              <Icon className="size-5" />
              <span className={ITEM_LABEL_CLASS}>{item.shortTitle ?? item.title}</span>
            </Link>
          );
        })}
        <button aria-expanded={openMobile} className={cn(ITEM_CLASS, openMobile && ITEM_ACTIVE_CLASS)} onClick={() => setOpenMobile(true)} type="button">
          <Menu className="size-5" />
          <span className={ITEM_LABEL_CLASS}>More</span>
        </button>
      </div>
    </nav>
  );
};
BottomNav.displayName = 'BottomNav';
